module.exports = __webpack_public_path__ + "media/img/pages/companies/mikron-new-9fa2832736a376c8300df9672c98463a.png";